import request from '@/utils/request'
export const loginByPassword = (data) => {
    return request({
        url: '/client/login/loginByPassword',
        method: 'POST',
        data: data
    })
}
export const loginByGoogle = (data) => {
    return request({
        url: '/client/login/googleLogin',
        method: 'POST',
        data: data
    })
}
export const register = (data) => {
    return request({
        url: '/client/login/register',
        method: 'POST',
        data: data
    })
}


// 发送邮件验证码（邮件发送可能需要较长时间，设置60秒超时）
export const sendMail = (data) => {
    return request({
        url: '/client/login/sendMail',
        method: 'POST',
        data: data,
        timeout: 6000  // 60秒超时
    })
}

export const editPasswordByCode = (data) => {
    return request({
        url: '/client/login/editPasswordByCode',
        method: 'POST',
        data: data
    })
}


// 设置密码
export const setPassword = (data) => {
    return request({
        url: '/client/user/setPassword',
        method: 'POST',
        data: data
    })
}

export const sendCode = (data) => {
    return request({
        url: '/client/vrificationCode/send',
        method: 'POST',
        data: data
    })
}


export const getInfo = () => {
    return request({
        url: '/client/user/getInfo',
        method: 'POST',

    })
}

export const editUser = (data) => {
    return request({
        url: '/client/user/edit',
        method: 'POST',
        data: data

    })
}

// 检测账号是否有设置密码
export const checkAccount = (data) => {
    return request({
        url: '/client/login/checkAccount',
        method: 'POST',
        data: data
    })
}